import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class SupervisionGuard  {
  constructor(private router: Router, private oauthService: OAuthService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const isAdmNat = this.isAdminNat();
    if (!isAdmNat) {
      this.router.navigate(['/subscriptions']);
    }
    return isAdmNat;
  }

  private isAdminNat() {
    const claims: any = this.oauthService.getIdentityClaims();
    if (claims) {
      return claims.user_type === 'ADM_NAT';
    }
    return false;
  }
}
